<script lang="ts">
  import { page } from '@inertiajs/svelte';

  // shared props 의 flash 를 읽는다. 정본 키는 notice / alert 다
  // (`ApplicationController#inertia_share` 주석 참조 — success/error 는 구 화면 호환용).
  //
  // 🔴 전역 레이아웃에 넣지 않는다. 이미 자체 flash 렌더를 가진 페이지가 여럿이라
  // 레이아웃에서 또 그리면 같은 안내가 두 번 뜬다. 필요한 페이지에만 붙인다.
  let flash = $derived((page.props.flash as Record<string, string | null>) || {})
  let notice = $derived(flash.notice || flash.success)
  let alert = $derived(flash.alert || flash.error)
</script>

{#if notice || alert}
  <div class="mb-4" style="word-break: keep-all; overflow-wrap: break-word;">
    {#if alert}
      <div role="alert"
           class="flex items-start gap-2 rounded-xl border border-amber-200 dark:border-amber-900/40 bg-amber-50 dark:bg-amber-900/20 px-4 py-3">
        <svg class="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
        </svg>
        <p class="text-sm text-amber-800 dark:text-amber-200">{alert}</p>
      </div>
    {/if}
    {#if notice}
      <div role="status"
           class="flex items-start gap-2 rounded-xl border border-emerald-200 dark:border-emerald-900/40 bg-emerald-50 dark:bg-emerald-900/20 px-4 py-3">
        <svg class="mt-0.5 h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-400" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <p class="text-sm text-emerald-800 dark:text-emerald-200">{notice}</p>
      </div>
    {/if}
  </div>
{/if}
